import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';
import DropDownLazy from '../../components/DropdownLazy';

import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import GerenciadorArquivoService from '../../services/GerenciadorArquivoService';

import ArquivoCategoriaService from '../../services/ArquivoCategoriaService';

import { cloneObj, errorHandle, validateFields } from '../../util/functions';

import { StateScreen } from '../constants';
import CalendarSp from '../../components/CalendarSp';
import { cfgPtBr } from '../../config/Constantes';

import { GerenciadorArquivoModel } from '../../util/Models';
import ArquivoSubcategoriaService from '../../services/ArquivoSubcategoriaService';
import InputTextSp from '../../components/InputTextSp';

function GerenciadorArquivoCrud(props) {
  GerenciadorArquivoCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  GerenciadorArquivoCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [gerenciadorArquivo, setGerenciadorArquivo] = useState(new GerenciadorArquivoModel());
  const [arquivoCategoriaSelecionado, setArquivoCategoriaSelecionado] = useState(null);
  const [arquivoSubcategoriaSelecionado, setArquivoSubcategoriaSelecionado] = useState(null);

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);
  const [fileName, setFileName] = useState();
  const [file, setFile] = useState();

  // useCallbacks

  const loadArquivoCategoria = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await ArquivoCategoriaService.findAll({ nome: _nome, limit: 50 });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const loadArquivoSubcategoria = useCallback(async _nome => {
    if (_nome !== undefined) {
      const r = await ArquivoSubcategoriaService.findAll({ nome: _nome, limit: 50 });

      const retorno = r.items.map(e => {
        return {
          label: e.nome,
          value: e.id,
        };
      });
      return retorno;
    }
    return [];
  }, []);

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await GerenciadorArquivoService.findById(_id);
      let categoria;
      let subcategoria;

      setGerenciadorArquivo({ ...retorno, data: new Date(retorno.data) });
      if (retorno) {
        categoria = {
          label: retorno.arquivoCategoria.nome,
          value: retorno.arquivoCategoria.id,
        };

        subcategoria = {
          label: retorno.arquivoSubcategoria.nome,
          value: retorno.arquivoSubcategoria.id,
        };
      }

      setArquivoCategoriaSelecionado(categoria);
      setArquivoSubcategoriaSelecionado(subcategoria);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      const mensagem = 'Confirma os dados';

      showMessage('Confirmação', mensagem, idx => {
        if (idx === 1) {
          salvarRecord();
        }
      });
    }
  }

  async function salvarRecord() {
    if (file) {
      if (file.size > 2000000001) {
        toast.warn('Arquivo nao pode ter tamanho superior a 200M');
        return;
      }
    }

    try {
      let retorno;

      const registroSalvar = cloneObj(gerenciadorArquivo);
      registroSalvar.file = file;

      if (stateScreen === StateScreen.stInsert) {
        retorno = await GerenciadorArquivoService.insert(registroSalvar);
      } else {
        retorno = await GerenciadorArquivoService.update(registroSalvar);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new GerenciadorArquivoModel();
      setArquivoCategoriaSelecionado(null);

      setGerenciadorArquivo(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <div className="p-col-12 p-sm-3 p-lg-3 p-fluid">
        <LabelSp>Data</LabelSp>
        <CalendarSp
          showOnFocus={false}
          showIcon
          required
          dateFormat="dd/mm/yy"
          disabled={viewMode()}
          locale={cfgPtBr}
          value={gerenciadorArquivo.data}
          appendTo={document.body}
          onChange={e => {
            setGerenciadorArquivo({
              ...gerenciadorArquivo,
              data: e.target.value,
            });
          }}
        />
      </div>
      <div className="p-col-12 p-sm-4 p-lg-4 p-fluid">
        <LabelSp>Categoria</LabelSp>
        <DropDownLazy
          required
          autoLoad
          disabled={viewMode()}
          placeholder="Selecione"
          onChange={e => {
            const gerenciadorArquivoTemp = e ? { id: e.value, nome: e.label } : null;
            setGerenciadorArquivo({
              ...gerenciadorArquivo,
              arquivoCategoria: gerenciadorArquivoTemp,
              idArquivoCategoria: e?.value || null,
            });
          }}
          value={arquivoCategoriaSelecionado}
          onFilter={async txtFilter => {
            const retorno = await loadArquivoCategoria(txtFilter);
            return retorno;
          }}
        />
      </div>

      <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
        <LabelSp>Subcategoria</LabelSp>
        <DropDownLazy
          required
          autoLoad
          disabled={viewMode()}
          placeholder="Selecione"
          onChange={e => {
            const gerenciadorArquivoTemp = e ? { id: e.value, nome: e.label } : null;
            setGerenciadorArquivo({
              ...gerenciadorArquivo,
              arquivoSubcategoria: gerenciadorArquivoTemp,
              idArquivoSubcategoria: e?.value || null,
            });
          }}
          value={arquivoSubcategoriaSelecionado}
          onFilter={async txtFilter => {
            const retorno = await loadArquivoSubcategoria(txtFilter);
            return retorno;
          }}
        />
      </div>

      <div className="p-col-12 p-md-12 p-lg-12 p-fluid">
        <LabelSp>Descrição</LabelSp>
        <InputTextSp
          value={gerenciadorArquivo.descricao}
          disabled={viewMode()}
          maxLength={100}
          required
          onChange={e => {
            setGerenciadorArquivo({ ...gerenciadorArquivo, descricao: e.target.value });
          }}
        />
      </div>

      {stateScreen !== StateScreen.stView && (
        <div className="p-col-12 p-sm-7 p-lg-7 p-fluid">
          <LabelSp>Upload Arquivo</LabelSp>
          <InputTextSp
            className="file"
            type="file"
            required={stateScreen === StateScreen.stInsert}
            accept=".JPG, .PNG, .PDF, .ZIP, .RAR, .7Z, .JPEG, .EXE, .MSI, .TXT, .XML, .JSON, .REL, .SQL"
            value={fileName}
            onChange={e => {
              const nomeArquivo = e.target.files[0].name || '';

              const fileRet = e.target.files && e.target.files[0] ? e.target.files[0] : null;
              setFileName(e.target.value);
              setGerenciadorArquivo({
                ...gerenciadorArquivo,
                nomeArquivo,
              });
              setFile(fileRet);
            }}
          />
          <span>Tamanho máximo permitido é de 200Mb</span>
        </div>
      )}
      <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
        <LabelSp>Arquivo Atual</LabelSp>
        <div style={{ display: 'flex' }}>
          <InputTextSp disabled value={gerenciadorArquivo.nomeArquivo} />
          {stateScreen === StateScreen.stView && (
            <ButtonSp
              style={{ marginLeft: 5 }}
              className="p-button-success buttons"
              title="Download"
              icon="pi pi-download"
              onClick={() => getFile(gerenciadorArquivo.nomeArquivo, gerenciadorArquivo.uri)}
            />
          )}
        </div>
      </div>

      {/* <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
        <LabelSp>.</LabelSp>
        <ButtonSp
          className="p-button-success buttons"
          title="Download"
          icon="pi pi-download"
          // onClick={() => getFile(rowData.tipo, rowData.nomeArquivo, rowData.uri)}
        />
      </div> */}

      <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
        {!viewMode() ? (
          <ButtonSp
            className="p-button-success"
            icon="pi pi-save"
            label="Salvar"
            keyAccess="S"
            disabled={
              !validateFields(gerenciadorArquivo, [
                'data',
                'idArquivoCategoria',
                'idArquivoSubcategoria',
              ])
            }
            onClick={handleSave}
          />
        ) : null}
        <ButtonSp
          className="p-button-secondary"
          label="Voltar"
          keyAccess="V"
          icon="pi pi-chevron-circle-left"
          onClick={handleBack}
        />
      </div>
    </>
  );

  async function getFile(nomeArquivo, uri) {
    let arquivoDownload;

    try {
      arquivoDownload = await GerenciadorArquivoService.getFile(uri);
    } catch (err) {
      errorHandle(err);
    }
    if (arquivoDownload) {
      const blob = new Blob([arquivoDownload]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      document.body.appendChild(link);
    }
  }
}

export default GerenciadorArquivoCrud;
